import {
	Component,
	OnInit,
	Input,
	OnDestroy,
	OnChanges,
	SimpleChanges,
	Output,
	EventEmitter,
	ElementRef,
	ViewChild,
	AfterContentInit,
	AfterViewInit,
	ViewEncapsulation,
	HostBinding,
	ChangeDetectionStrategy
} from "@angular/core";

import { trigger, state, style, animate, transition } from "@angular/animations";

@Component({
	selector: "rbc-transition-new",
	template: `
		<ng-container *ngIf="state">
		<div *ngIf="name === 'opacity'"
		[@opacity]
		(@opacity.done)="animationDone($event)"
		(@opacity.start)="animationStart($event)">
			<ng-container *ngTemplateOutlet="bodyTmp"></ng-container>
		</div>

		<div *ngIf="name === 'height'" [@height]="{value:state}">
			<ng-container *ngTemplateOutlet="bodyTmp"></ng-container>
		</div>

		<div *ngIf="name === 'opacity-height'"
		[@opacity-height]="{value:state}"
		(@opacity-height.done)="animationDone($event)">
			<ng-container *ngTemplateOutlet="bodyTmp"></ng-container>
		</div>

		<div *ngIf="name === 'opacity-up'" [@opacity-up]="{value:state}">
			<ng-container *ngTemplateOutlet="bodyTmp"></ng-container>
		</div>

		<div *ngIf="name === 'opacity-down'" [@opacity-down]="{value:state}">
			<ng-container *ngTemplateOutlet="bodyTmp"></ng-container>
		</div>

		<div *ngIf="name === 'opacity-left'" [@opacity-left]="{value:state}">
			<ng-container *ngTemplateOutlet="bodyTmp"></ng-container>
		</div>

		<div *ngIf="name === 'opacity-right'" [@opacity-right]="{value:state}">
			<ng-container *ngTemplateOutlet="bodyTmp"></ng-container>
		</div>

		<div *ngIf="name === 'opacity-max-height'" [@opacity-max-height]="{value:state}">
			<ng-container *ngTemplateOutlet="bodyTmp"></ng-container>
		</div>

		<div *ngIf="name === 'max-height'" [@max-height]="{value:state}"
		(@max-height.done)="animationDone($event)">
			<ng-container *ngTemplateOutlet="bodyTmp"></ng-container>
		</div>
		</ng-container>

	<ng-template #bodyTmp>
		<ng-content></ng-content>
	</ng-template>

	`,
	encapsulation: ViewEncapsulation.None,
	animations: [
		// trigger("opacity", [
		// 	state("true", style({
		// 		overflow: "hidden",
		// 		opacity: 1
		// 	})),
		// 	state("false", style({
		// 		overflow: "hidden",
		// 		opacity: 0
		// 	})),
		// 	transition("* => false", animate("250ms ease-in")),
		// 	transition("* => true", animate("250ms ease-out"))
		// ]),
		trigger("opacity", [
			transition(":enter", [
				style({ opacity: 0}),
				animate("250ms ease-in", style({ opacity: 1}))
			]),
			transition(":leave", [
				animate("250ms ease-out", style({ opacity: 0 }))
			])
			// state('*', style({ opacity: 1 }))
		]),
		// trigger("opacity-up", [
		// 	state("true", style({
		// 		overflow: "hidden",
		// 		opacity: 1,
		// 		transform: "translateY(0)"
		// 	})),
		// 	state("false", style({
		// 		height: "0px",
		// 		overflow: "hidden",
		// 		opacity: 0,
		// 		transform: "translateY(1.5rem)"
		// 	})),
		// 	transition("true => false", animate("400ms ease-out")),
		// 	transition("false => true", animate("400ms ease-in"))
		// ]),
		trigger("opacity-up", [
			transition(":enter", [
				style({ opacity: 0, transform: "translateY(1.5rem)" }),
				animate("0.2s", style({ opacity: 1, transform: "translateY(0)" }))
			]),
			transition(":leave", [
				animate("0.2s", style({ opacity: 0, transform: "translateY(1.5rem)" }))
			])
		]),
		trigger("opacity-down", [
			transition(":enter", [
				style({ opacity: 0, transform: "translateY(-1.5rem)"}),
				animate("0.2s", style({ opacity: 1, transform: "translateY(0)"}))
			]),
			transition(":leave", [
				animate("0.2s", style({ opacity: 0 , transform: "translateY(-1.5rem)" }))
			])
		]),
		// trigger("opacity-down", [
		// 	state("true", style({
		// 		overflow: "hidden",
		// 		opacity: 1,
		// 		transform: "translateY(0)"
		// 	})),
		// 	state("false", style({
		// 		overflow: "hidden",
		// 		opacity: 0,
		// 		transform: "translateY(-1.5rem)"
		// 		// height: 0
		// 	})),
		// 	transition("true => false", animate("400ms ease-out")),
		// 	transition("false => true", animate("400ms ease-in"))
		// ]),
		trigger("opacity-left", [
			transition(":enter", [
				style({ opacity: 0, transform: "translateX(-1.5rem)" }),
				animate("0.2s", style({ opacity: 1, transform: "translateX(0)" }))
			]),
			transition(":leave", [
				animate("0.2s", style({ opacity: 0, transform: "translateX(-1.5rem)" }))
			])
		]),
		trigger("opacity-right", [
			transition(":enter", [
				style({ opacity: 0, transform: "translateX(1.5rem)" }),
				animate("0.2s", style({ opacity: 1, transform: "translateX(0)" }))
			]),
			transition(":leave", [
				animate("0.2s", style({ opacity: 0, transform: "translateX(1.5rem)" }))
			])
		]),
		// trigger("opacity-left", [
		// 	state("true", style({
		// 		overflow: "hidden",
		// 		transform: "translateX(1.5rem)",
		// 		opacity: 1
		// 	})),
		// 	state("false", style({
		// 		overflow: "hidden",
		// 		transform: "translateX(-1.5rem)",
		// 		opacity: 0
		// 	})),
		// 	transition("true => false", animate("400ms ease-out")),
		// 	transition("false => true", animate("400ms ease-in"))
		// ]),
		// trigger("opacity-right", [
		// 	state("true", style({
		// 		overflow: "hidden",
		// 		transform: "translateX(-1.5rem)",
		// 		opacity: 1
		// 	})),
		// 	state("false", style({
		// 		transform: "translateX(1.5rem)",
		// 		overflow: "hidden",
		// 		opacity: 0
		// 	})),
		// 	transition("true => false", animate("400ms ease-out")),
		// 	transition("false => true", animate("400ms ease-in"))
		// ]),
		trigger("opacity-height", [
			transition(":enter", [
				style({ opacity: 0, height: "0px", overflow: "hidden"}),
				animate("0.4s ease-in-out", style({ opacity: 1, overflow: "hidden", height: "*"}))
			]),
			transition(":leave", [
				style({ opacity: 1, height: "*", overflow: "hidden" }),
				animate("0.4s ease-out", style({ opacity: 0, overflow: "hidden", height: "0px" }))
			])
		]),
		// trigger("opacity-height", [
		// 	state("true", style({
		// 		overflow: "hidden",
		// 		height: "*",
		// 		opacity: 1
		// 	})),
		// 	state("false", style({
		// 		height: "0px",
		// 		overflow: "hidden",
		// 		opacity: 0
		// 	})),
		// 	transition("true => false", animate("400ms ease-out")),
		// 	transition("false => true", animate("400ms ease-in"))
		// ]),
		trigger("opacity-max-height", [
			transition(":enter", [
				style({ opacity: 0, maxHeight: "0px", overflow: "hidden" }),
				animate("0.4s ease-in-out", style({ opacity: 1, overflow: "hidden", maxHeight: "*" }))
			]),
			transition(":leave", [
				style({ opacity: 1, maxHeight: "*", overflow: "hidden" }),
				animate("0.4s ease-out", style({ opacity: 0, overflow: "hidden", maxHeight: "0px" }))
			])
		]),
		// trigger("opacity-max-height", [
		// 	state("true", style({
		// 		overflow: "hidden",
		// 		height: "*",
		// 		opacity: 1
		// 	})),
		// 	state("false", style({
		// 		height: "0px",
		// 		overflow: "hidden",
		// 		opacity: 0
		// 	})),
		// 	transition("true => false", animate("400ms ease-out")),
		// 	transition("false => true", animate("400ms ease-in"))
		// ]),
		trigger("height", [
			transition(":enter", [
				style({ height: "0px", overflow: "hidden" }),
				animate("0.4s ease-in-out", style({ overflow: "hidden", height: "*" }))
			]),
			transition(":leave", [
				style({ height: "*", overflow: "hidden" }),
				animate("0.4s ease-out", style({ overflow: "hidden", height: "0px" }))
			])
		]),
		// trigger("height", [
		// 	state("true", style({
		// 		overflow: "hidden",
		// 		height: "*"
		// 	})),
		// 	state("false", style({
		// 		height: "0px",
		// 		overflow: "hidden"
		// 	})),
		// 	transition("true => false", animate("400ms ease-out")),
		// 	transition("false => true", animate("400ms ease-in"))
		// ]),
		trigger("max-height", [
			transition(":enter", [
				style({ height: "0px", overflow: "auto" }),
				animate("0.4s ease-in-out", style({ overflow: "auto", height: "*" }))
			]),
			transition(":leave", [
				style({ height: "*", overflow: "auto" }),
				animate("0.4s ease-out", style({ overflow: "auto", height: "0px" }))
			])
		])
		// trigger("max-height", [
		// 	state("true", style({
		// 		height: "*",
		// 		overflow: "hidden"
		// 	})),
		// 	state("false", style({
		// 		height: "0px",
		// 		"visibility": "hidden",
		// 		overflow: "hidden"
		// 	})),
		// 	transition("true => false", animate("400ms ease-in-out")),
		// 	transition("false => true", animate("400ms ease-in-out"))
		// ])
	],
	changeDetection: ChangeDetectionStrategy.OnPush

})
export class TransitionNewComponent implements OnChanges {

	@Input() currentState;
	@Input() name;
	@Input() mode;
	@Input() appear;
	@Input() group;
	@Input() tag;
	@Input() state;
	@Output() onTransition = new EventEmitter<any>();

	// height =  "auto";
	isShown = true;
	startHeight: number;

	constructor(private element: ElementRef) { }

	@HostBinding("@height") get grow() {
		return { params: { startHeight: this.startHeight } };
	}

	setStartHeight() {
		this.startHeight = this.element.nativeElement.offsetHeight;
	}

	ngOnChanges() {
		this.setStartHeight();
	}


	animationDone(event: AnimationEvent) {
		// now remove the
		// console.log(event);
		// if (event.fromState === "visible" && event.toState === "hidden") {

		// }
	}

	animationStart(event) {
		this.onTransition.emit({
			type: "enter",
			element: event.element.lastElementChild
		});
	}
}
